// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","stepperWrapper":"_3fHu44vsZmVFiL-uFY_Ace","stepper":"flqgGz06YK-RZvbVyl_Ei","step":"_1W5IqboFeXubptkTaJZT3W","active":"yBs95WWB35zI1a5Yx53oV"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SignUp/components/Stepper/Stepper.mod.css
// module id = 1601
// module chunks = 0